export default __webpack_public_path__ + "static/media/arei.ba3aef89.svg";